import { errorCodes } from './errorCodes';
import type { ErrorCode } from './types/ErrorCode';
import type { ErrorData } from './types/ErrorData';

// TODO: Consider moving to packages/common (after issues with HMR and exports are resolved)
export class ApplicationError extends Error {
  readonly code: string;
  readonly codeDescription: string;
  readonly signature: string;
  readonly timestamp: string;

  constructor(code: ErrorCode, message?: string) {
    const now = new Date();
    const timestamp = now.toISOString() + now.getTimezoneOffset().toString();
    const signature = `[${code}|${timestamp}]`;
    const codeDescription = errorCodes[code];

    super(`${signature} ${message ?? codeDescription}`);
    this.code = code;
    this.codeDescription = errorCodes[code];
    this.name = 'ApplicationError';
    this.signature = signature;
    this.timestamp = timestamp;
  }

  toErrorData(): ErrorData {
    const data: ErrorData = {
      code: this.code,
      codeDescription: this.codeDescription,
      message: this.message,
      name: this.name,
      signature: this.signature,
      timestamp: this.timestamp,
    };

    // Consider deep cause chain (ApplicationError, Error)
    if (this.cause && this.cause instanceof Error) {
      data.causeMessage = this.cause.message;
    }

    return data;
  }
}
